import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

// Reusable pagination bar for server-paginated tables.
// Props: page, pages, total, pageSize, onPage(newPage), testId.
export function DataPagination({ page = 1, pages = 1, total = 0, pageSize = 50, onPage, testId = "pagination" }) {
  if (!total) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-3 border-t border-border text-sm flex-wrap" data-testid={testId}>
      <span className="text-muted-foreground" data-testid={`${testId}-summary`}>
        {from.toLocaleString()}–{to.toLocaleString()} of {total.toLocaleString()}
      </span>
      <div className="flex items-center gap-2">
        <Button
          variant="outline" size="sm" className="h-8 gap-1"
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
          data-testid={`${testId}-prev`}
        >
          <ChevronLeft className="w-4 h-4" /> Prev
        </Button>
        <span className="text-muted-foreground px-1" data-testid={`${testId}-page`}>
          Page {page} / {pages}
        </span>
        <Button
          variant="outline" size="sm" className="h-8 gap-1"
          disabled={page >= pages}
          onClick={() => onPage(page + 1)}
          data-testid={`${testId}-next`}
        >
          Next <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}

export default DataPagination;
